import { render } from "./index.vue?vue&type=template&id=c02e6464&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c02e6464&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=c02e6464&lang=css"
import "./index.vue?vue&type=style&index=2&id=c02e6464&lang=scss&scoped=true"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c02e6464"]])

export default __exports__